import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import { inject, observer } from 'mobx-react';
import { SpaceModel } from '../../../model/block';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import styled from 'styled-components';
import {getCenterOfPageStyle} from '../../../util/style/get-center-of-page-style';

const SpaceWrapper = styled.div<{ backgroundColor: string; height: number }>`
  padding: 0;
  word-wrap: break-word;
  background: ${(props) => props.backgroundColor};
  height: ${(props) => props.height}px;
  ${getCenterOfPageStyle()}
`;

@inject('state')
@observer
export class SpaceView extends BaseBlockView<SpaceModel, IInjectedProps> {
  render() {
    return <SpaceWrapper
        backgroundColor={this.props.state.colors.getColor(this.props.content.spaceBackgroundColor)}
        height={Number(this.props.content.height)}
    >
      &nbsp;
    </SpaceWrapper>;
  }
}
